import { render } from "./TextSetting.vue?vue&type=template&id=0a84901e&scoped=true"
import script from "./TextSetting.vue?vue&type=script&lang=js"
export * from "./TextSetting.vue?vue&type=script&lang=js"

import "./TextSetting.vue?vue&type=style&index=0&id=0a84901e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a84901e"]])

export default __exports__